import { ContainerModule } from 'inversify';
import { StateSerializationPluginSymbol } from '@/app/state-serialization/api';
import { PracticeSessionStateProtobufSerializer } from './practice-session-state-protobuf-serializer'

export const practiceSessionTrackingSerializationModule = new ContainerModule((bind) => {
  bind(StateSerializationPluginSymbol).to(PracticeSessionStateProtobufSerializer)
});
